var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col justify-between flex-grow h-full gap-2" },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center content-center justify-center h-full"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex w-full gap-4 pb-4 overflow-x-auto scrolling-touch max-w-72 snap-x-mandatory scrollbar-lg",
              attrs: {
                id: "percentage-scroll-" + _vm.measurement.id,
                dir: "ltr"
              },
              on: { scroll: _vm.onScroll }
            },
            _vm._l(_vm.percentageBoxesPages, function(percentageBoxes, idx) {
              return _c(
                "div",
                {
                  key: _vm.measurement.id + "-percentage-boxes-" + (idx + 1),
                  staticClass:
                    "flex justify-center flex-shrink-0 w-full snap-center",
                  attrs: {
                    id: _vm.measurement.id + "-percentage-boxes-" + (idx + 1)
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-wrap items-start content-center justify-center w-full transition-all duration-300",
                      class: [
                        _vm.isCollapsed
                          ? "gap-2"
                          : _vm.sessionStatus === "draft"
                          ? "gap-2 2xl:gap-3"
                          : "gap-3"
                      ]
                    },
                    _vm._l(percentageBoxes, function(box) {
                      return _c(
                        "div",
                        {
                          key: box.key,
                          staticClass:
                            "flex items-center justify-center flex-shrink-0 transition-all duration-300 border rounded cursor-pointer",
                          class: {
                            "h-7.5 w-7.5 xl:h-8 xl:w-8 2xl:h-10 2xl:w-10":
                              _vm.sessionStatus === "draft",
                            "h-10 w-10": _vm.sessionStatus !== "draft",
                            "cursor-wait":
                              _vm.percentageLoadingBox &&
                              _vm.percentageLoadingBox !== box.key,
                            "pointer-events-none":
                              _vm.sessionStatus !== "ongoing",
                            "border-slate-500 bg-pure-white":
                              box.value === null,
                            "border-grass-700 bg-grass-100": box.value === true,
                            "border-tomato-700 bg-tomato-100":
                              box.value === false
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChangePercentage(box)
                            }
                          }
                        },
                        [
                          box.value === true
                            ? _c("BlIcon", {
                                staticClass: "w-10 h-10",
                                attrs: { icon: "check", color: "success" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          box.value === false
                            ? _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: { icon: "close", color: "error" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 pb-3 space-y-2",
          class: { "-translate-y-2": _vm.isCollapsed }
        },
        [
          _c(
            "div",
            { staticClass: "z-10 flex items-center justify-center h-3 gap-2" },
            _vm._l(_vm.pageCount, function(n) {
              return _c("div", {
                key: n,
                staticClass:
                  "w-3 h-3 transition-all duration-300 rounded-full cursor-pointer",
                class: {
                  "bg-slate-700": n === _vm.page,
                  "bg-slate-400": n !== _vm.page
                },
                on: {
                  click: function($event) {
                    return _vm.onChangePage(n)
                  }
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass:
                    "z-10 flex items-center justify-center gap-2 text-center"
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", { attrs: { text: "Goal:" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: _vm.measurement.target.goal + "%" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", { attrs: { text: "Score:" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: _vm.percentageScore.toFixed(0) + "%" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sessionStatus === "draft" && _vm.measurement.target.probing_enable
            ? _c(
                "div",
                {
                  staticClass:
                    "z-10 flex items-center justify-between w-full px-4 py-2 rounded-full bg-pure-white"
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-lime-700",
                        attrs: { text: "Set as probing" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.measurement.type
                    ? _c(
                        "div",
                        { staticClass: "flex gap-1" },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-lime-700",
                            attrs: {
                              text: _vm.measurement.type.includes("Probing")
                                ? "Yes"
                                : "No"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputToggle", {
                            attrs: {
                              checked: _vm.measurement.type.includes("Probing"),
                              color: "lime",
                              loading: _vm.switchLoading
                            },
                            on: { changed: _vm.onChangeProbing }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-444ffe37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444ffe37","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/Percentage.vue
// module id = null
// module chunks = 